const brand = {
  light: "AntennaLight",
  regular: "AntennaRegular",
  medium: "AntennaMedium",
  bold: "AntennaBold",
  condensedBold: "AntennaCondensedBold",
};

const fallbacks = {
  default: "Roboto, Helvetica, sans-serif, FordEmoji",
  header: "Montserrat, sans-serif",
};

export const fonts = {
  brand,
  brandLight: `${brand.light}, ${fallbacks.default}`,
  brandRegular: `${brand.regular}, ${fallbacks.default}`,
  brandMedium: `${brand.medium}, ${fallbacks.default}`,
  brandBold: `${brand.bold}, ${fallbacks.default}`,
  brandCondensedBold: `${brand.condensedBold}, ${fallbacks.default}`,
  default: `${brand.regular}, ${fallbacks.default}`,
  header: `${brand.bold}, ${fallbacks.header}`,
};
